import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import { makeStyles, Theme } from '@material-ui/core/styles'

interface SidebarProps {
  isOpen: boolean
}

export const SidebarContainer = styled.aside<SidebarProps>`
  position: fixed;
  width: 100%;
  height: 100%;
  background: #292566;
  top: 0;
  left: 0;
  transition: 0.3s ease-in-out;

  opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};

  z-index: 998;
`
export const SidebarWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  margin-top: 7.5rem;
`

export const SidebarMenu = styled.ul`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding-left: 24px;
  gap: 30px;
`

export const Link = styled(LinkR)`
  color: #fff;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  list-style: none;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #fec074;
  }
`

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 24px 24px;

  input {
    width: 100%;
    height: 100%;
    border-radius: 30px;
    outline: none;
    border: none;
    padding: 12px 85px 12px 16px;
  }
`

export const SearchIcon = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  right: 0;
  margin-right: 32px;
`

export const ClearIcon = styled.img`
  width: 25px;
  height: 25px;
  position: absolute;
  right: 0;
  margin-right: 70px;
`

interface StyleProps {
  isOpen: boolean;
}

export const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  sidebarContainer: (props) => ({
    position: 'fixed',
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    top: props ? '0%' : '-100%',
    opacity: props ? '100%' : '0%',
    left: 0,
    transition: '0.3s ease-in-out',
    zIndex: 998
  }),
  typography: {
    fontSize: '1.2rem'
  },
  hoverLink: {
    '&:hover': {
      textShadow: '0.05em 0px currentColor'
    }
  },
  sidebarWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '7.5rem'
  },
  sidebarMenu: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    paddingLeft: '24px',
    gap: '30px'
  }
}))
